// Image extensions
export const IMAGE_EXTENSIONS = [".jpg", ".jpeg", ".png"];

// Video extensions
export const VIDEO_EXTENSIONS = [".mp4", ".mov", ".avi", ".wmv", ".mkv", ".webm", ".flv"];

//media extensions
export const MEDIA_EXTENSIONS = [
  ...IMAGE_EXTENSIONS, 
  ...VIDEO_EXTENSIONS
];

// _______________________________________________

// Document extensions
export const PDF_EXTENSIONS = [".pdf"];
export const EXCEL_EXTENSIONS = [".xls", ".xlsx", ".csv"];
export const WORD_EXTENSIONS = [".doc", ".docx"];
export const POWERPOINT_EXTENSIONS = [".ppt", ".pptx"];
export const TEXT_EXTENSIONS = [".txt"];

// All document extensions grouped
export const DOCUMENT_EXTENSIONS = [
  ...PDF_EXTENSIONS,
  ...EXCEL_EXTENSIONS,
  ...WORD_EXTENSIONS,
  ...POWERPOINT_EXTENSIONS,
  ...TEXT_EXTENSIONS
];

// All extensions
export const ALL_EXTENSIONS = [
  ...MEDIA_EXTENSIONS,
  ...DOCUMENT_EXTENSIONS
];

// _______________________________________________
// File helpers (kept here so the FilesHandler module is self-contained)

const getFileExtension = (file) => {
  if (typeof file === "string") {
    const parts = file.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  }
  return "";
};

export const isFileImage = (file) => {
  const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"];
  const extension = getFileExtension(file);
  return imageExtensions.includes(extension.toLowerCase());
};

export const loadFileIcon = (file) => {
  if (isFileImage(file)) {
    return file;
  }

  const extension = getFileExtension(file);
  return `/assets/icons/${extension || "unknown"}.png`;
};

/**
 * Fetches a remote/URL file and materializes it into a browser File object.
 * Returns null on any failure so callers can decide how to surface the error.
 */
export const convertUrlToFileObject = async (url, fileName = null) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    let finalFileName = fileName;
    if (!finalFileName) {
      const urlParts = String(url).split("/");
      // strip any query string from the derived name
      finalFileName = (urlParts[urlParts.length - 1] || "file").split("?")[0];
    }

    return new File([blob], finalFileName, { type: blob.type });
  } catch (error) {
    return null;
  }
};
